// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3emX7){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3XbKC .dualColumn_2Ac2d{display:flex;align-content:space-between}.nsAddressForm_3XbKC .dualColumn_2Ac2d .firstCol_3vJ1V{margin-right:20px}.optional_2rqow{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3emX7",
	"nsAddressForm": "nsAddressForm_3XbKC",
	"dualColumn": "dualColumn_2Ac2d",
	"firstCol": "firstCol_3vJ1V",
	"optional": "optional_2rqow"
};
module.exports = exports;
